import React from 'react';
import { Animated } from 'react-animated-css';
import { Popover, PopoverBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import moment from 'moment';
import _, { slice } from 'lodash';
import fakeAuth from '../../../fakeAuth';
import request from 'superagent';
import config from '../../../config';

class AuditTransactionForm extends React.Component {
    state = {
        mode: 1,
        validations: {},
        transaction: {},
        other: 0,
        dirty: false,
        IdProperty: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).IdProperty : null,
    }

    componentWillMount = () => {
        const { transaction } = this.props;
        this.setState({ transaction });        
    }

    validate = (e) => {
        e && e.preventDefault && e.preventDefault();
        if (this.state.microTransact) return;
        this.setState({ validations: {} }, () => {
            const { validations, transaction } = this.state;

            const { id } = this.props.params, { IdProperty } = this.state;

            if (!this.txtReason.value) {
                validations.txtReason = 'Por favor, introduce las notas de la auditoria';
                this.setState({ validations }, () => { this.txtReasonWrapper.scrollIntoView({ behavior: 'smooth' }); });
                return;
            }
            if (!this.txtAmount.value) {
                validations.txtAmount = 'Por favor, introduce el monto de la transacción';
                this.setState({ validations }, () => { this.txtAmountWrapper.scrollIntoView({ behavior: 'smooth' }); });
                return;
            }


            this.setState({ microTransact: true }, () => {
                // CALL API                                
                request.post(`${config.apiEndpoint}/api/v4/accounting/audit_transaction`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({
                        ...transaction,
                        NEW_AMOUNT: this.txtAmount.value,
                        NEW_REASON: this.txtReason.value
                    })
                    .then((data) => {
                        if (data.body.success) {
                            // CALL API to refresh p: ayments
                            this.props.accounting_actions && this.props.accounting_actions.fetch(this.props.params.id);
                            this.props.toggle && this.props.toggle();
                        }
                    }, (error) => {
                        this.setState({ microTransact: false, error: 'Something wrong' });
                        //this.props.setDeveloperMessage && this.props.setDeveloperMessage(error);
                    });
            });

        });
    }

    render() {
        const { mode, validations, transaction } = this.state, { auxiliar } = this.props;
        const { payment_types } = config;

        let user = fakeAuth.getUser();
        let auditor = false;
        if ((user.Permissions & (config.permissions.Approve)) !== 0) auditor = true;

        return <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
            <div className="black-input bg-gray-2 p-4 align-self-center" style={{ width: 400 }}>

                {!auditor && <div className="bg-danger mt-4 p-4 rounded d-flex flex-row justify-content-center">
                    <i className="fas fa-exclamation-triangle me-2 align-self-center font-20 white" />
                    <span className="align-self-center font-10 line1 white">Solo un auditor puede modificar estos campos.</span>
                </div>}

                {/* CONCEPTO */}
                <div className="w-100 mt-4" ref={i => this.txtReasonWrapper = i}>
                    <label className="white poppins font-12">Notas</label>
                    <div id="txtReason" className={`black-input ${validations.txtReason ? 'error-input' : ''} d-flex mt-2`}>
                        <textarea className="w-100 p-3 white" type="text" name="name" placeholder="Notas" ref={(input) => this.txtReason = input} defaultValue={transaction.AuditComment} />
                    </div>
                    <Popover placement="right" isOpen={validations.txtReason ? true : false} target={`txtReason`} toggle={() => {
                        const { validations } = this.state;
                        validations.txtReason = !validations.txtReason;
                        this.setState({ validations });
                    }} className="bg-gray-2">
                        <PopoverBody className="d-flex flex-row justify-content-center">
                            <i className="fas fa-times red font-8 align-self-center" />
                            <span className="white font-8 poppins align-self-center ms-3" style={{ maxWidth: 100 }}>{validations.txtReason}</span>
                        </PopoverBody>
                    </Popover>
                </div>
                {transaction.AuditIdUser && <span className="gray font-8 ms-auto me-2 text-right block">{`${transaction.AuditFirstName} ${transaction.AuditLastName} @ ${moment(transaction.AuditDate).format('MMM Do YYYY @ hh:mmA')}`}</span>}

                {/* MONTO */}
                <div className={`w-100 mt-4`} ref={i => this.txtAmountWrapper = i}>
                    <label className="white poppins font-12">Monto <i className="blue">*</i></label>
                    <div id="txtAmount" className={`black-input ${validations.txtAmount ? 'error-input' : ''} d-flex mt-2 ${this.state.dirty ? 'yellow-border' : ''}`}>
                        <i className="fas fa-dollar whiteish font-20 align-self-center ms-3" />
                        <input onChange={e => {
                            if (!_.isNaN(parseFloat(e.target.value))) this.setState({ dirty: true, other: parseFloat(e.target.value) * 0.03 });
                        }} className="w-100 p-3 white" type="text" name="amount"
                            placeholder="Monto" ref={(input) => this.txtAmount = input} defaultValue={parseFloat(transaction.Debit) > 0 ? transaction.Debit : transaction.Credit} />
                    </div>
                    <Popover placement="right" isOpen={validations.txtAmount ? true : false} target={`txtAmount`} toggle={() => {
                        const { validations } = this.state;
                        validations.txtAmount = !validations.txtAmount;
                        this.setState({ validations });
                    }} className="bg-gray-2">
                        <PopoverBody className="d-flex flex-row justify-content-center">
                            <i className="fas fa-times red font-8 align-self-center" />
                            <span className="white font-8 poppins align-self-center ms-3" style={{ maxWidth: 100 }}>{validations.txtAmount}</span>
                        </PopoverBody>
                    </Popover>
                </div>

                {/* BUTTONS */}
                <div className="d-flex justify-content-center mt-4">
                    <button onClick={this.props.toggle} type="button" className="btn btn-lg btn-gray-2 white align-self-center" >
                        <i className="fas fa-times white font-12" />
                    </button>
                    {(auditor) && <button onClick={this.validate} type="button" className={`btn btn-lg btn-${this.state.dirty ? 'warning black' : 'blue white'}  ms-3 align-self-center`} >
                        {!this.state.microTransact && <i className="fas fa-check white font-12" />}
                        {this.state.microTransact && <i className="fas fa-cog fa-spin white font-12" />}
                    </button>}
                </div>
                {this.state.dirty === true && auditor && <div className="bg-warning mt-4 p-4 rounded d-flex flex-row justify-content-center">
                    <i className="fas fa-exclamation-triangle me-2 align-self-center font-20" />
                    <span className="align-self-center font-10 line1"> Este cambio no puede ser revertido. Se re-calcularan las tarifas aplicadas.</span>
                </div>}


            </div>
        </div >
    }

}

export default AuditTransactionForm;